import { request } from "../../utils";
import { locationRestConsentClearDelete } from "../../wp-api";
/**
 * Delete cookies on server side (currently only `http`).
 */

function deleteCookiesServer(cookies) {
  return request({
    location: locationRestConsentClearDelete,
    params: {
      cookies: cookies.join(",")
    }
  });
}

export { deleteCookiesServer };